/**
 * Model for API CustomerSupplier Model
 */
export class Supplier {
  /**
   * Back-end identifier
   */
  id: number;

  /**
   * Supplier entity identifier
   */
  supplierEntity: string;

  /**
   * Supplier sub entity identifier
   */
  supplierSubEntity: string;

  constructor(attributes: Partial<Supplier> = {}) {
    Object.assign(this, attributes);
  }

  toString(): string {
    return `${this.id} ${this.supplierEntity} ${this.supplierSubEntity}`;
  }
}
